import {
  RESET_NOTEPAD,
  API_ERROR,
  GET_NOTEPAD,
  SET_NOTEPAD,
  UPDATE_NOTEPAD,
  UPDATE_NOTEPAD_SUCCESS,
  SET_NOTEPAD_CONTENT,
  TOGGLE_NOTEPAD,
} from "./actionTypes";

const initialState = {
  content: "",
  errorNotepad: false,
  loadingNotepad: false,
  dataNotepad: null,
  successNotepad: false,
  isOpen: false,
};

const Notepad = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_NOTEPAD:
      state = {
        ...state,
        isOpen: !state.isOpen,
      };
      break;
    case GET_NOTEPAD:
      state = {
        ...state,
        errorNotepad: false,
        loadingNotepad: true,
        dataNotepad: null,
      };
      break;
    case SET_NOTEPAD:
      state = {
        ...state,
        loadingNotepad: false,
        dataNotepad: action.payload,
        successNotepad: false,
      };
      break;
    case RESET_NOTEPAD:
      state = {
        ...state,
        loadingNotepad: false,
        errorNotepad: false,
        successNotepad: false,
      };
      break;
    case UPDATE_NOTEPAD:
      state = {
        ...state,
        dataNotepad: action.payload,
        loadingNotepad: true,
        successNotepad: false,
      };
      break;
    case UPDATE_NOTEPAD_SUCCESS:
      state = {
        ...state,
        dataNotepad: action.payload,
        loadingNotepad: false,
        successNotepad: true,
      };
      break;

    case API_ERROR:
      state = {
        ...state,
        errorNotepad: action.payload,
        loadingNotepad: false,
        successNotepad: false,
        dataNotepad: null,
      };
      break;

    case SET_NOTEPAD_CONTENT:
      state = {
        ...state,
        content: action.payload,
      };
      break;

    default:
      state = {
        ...state,
        errorNotepad: false,
      };
      break;
  }
  return state;
};

export default Notepad;
